import { TagType } from 'src/app/shared/components/tag/tag.component';
import {
  AlertReportDetailDto,
  WalletRegistryAlertDto,
} from 'src/generated-sources/openapi/alert-service/alert';

export interface WalletRegistryAlertResponse extends WalletRegistryAlertDto {
  _combinedAlerts?: AlertReportDetailDto[];
}

export interface FlattenedIndicator {
  id: string | null;
  name: string;
  isParentIndicator: boolean;
  indicatorIds: string[];
  relationshipLevel?: RelationshipLevel;
}

export interface PaginationState {
  page: number;
  perPage: number;
  totalRegisters: number;
}

export interface AlertReportTag extends AlertReportDetailDto {
  visible: boolean;
  measuredWidth: number;
  text: string;
  type: TagType;
}

export enum RelationshipLevel {
  ROOT = 'ROOT',
  L1 = 'L1',
  L2 = 'L2',
}

export interface AlertIndicatorVariation {
  id?: string;
  indicatorId?: string;
  indicatorGroup: string;
  relationshipLevel?: RelationshipLevel;
  category?: string;
  previousQuantity?: string;
  currentQuantity?: string;
  previousValue?: string;
  currentValue?: string;
  isRegistrationData?: boolean;
  isPartnerRegistrationData?: boolean;
  isPartnerShareholdingData?: boolean;
  isLoadingPlaceholder?: boolean;
}
